import { ChangeDetectionStrategy, Component, Input, OnDestroy, inject } from "@angular/core";
import { Store } from "@ngxs/store";
import * as TagManagerActions from "@vp/tag-manager/data-access/tag-manager-state";
import { Subject } from "rxjs";

@Component({
  selector: "vp-tag-search-input",
  templateUrl: "./tag-search-input.component.html",
  styleUrls: ["./tag-search-input.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TagSearchInputComponent implements OnDestroy {
  private readonly store = inject(Store);

  destroy$ = new Subject<void>();

  @Input() title = "";
  @Input() placeholder = "";
  @Input() search = "";
  @Input() entity = "";
  @Input() debounce = 100;

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onKeyUp = ($event: any) => {
    if (this.entity === "Tag") {
      this.store.dispatch(
        new TagManagerActions.UpdateState({
          tagSearch: $event.target.value
        })
      );
    } else {
      this.store.dispatch(
        new TagManagerActions.UpdateState({
          tagTypeSearch: $event.target.value
        })
      );
    }
  };
}
